<template>
    <div class="text-center">
        <i class="fas fa-box fa-3x text-muted"></i>
        <h4 class="mb-0">กรุณากรอกหมายเลขติดตามพัสดุ</h4>
        <div class="py-3">
            <input 
                type="text" 
                class="form-control" 
                placeholder="กรอกหมายเลขติดตามพัสดุ"
                v-model="tracking.code"
            />
        </div>
        <b-button class="px-5" variant="primary" :disabled="tracking.code.length < 11" @click="$emit('onSearch')" >
            <i class="fas fa-circle-notch fa-spin" v-if="tracking.isLoadTracking"></i> ค้นหา
        </b-button>
    </div>
</template>

<script>
export default {
    name:"searchtracking",
    props:{
        tracking: Object
    }
}
</script>